export const rankTable = [
  { rank: 20, xp: 35000000, title: "Capitalist" },
  { rank: 19, xp: 20000000, title: "Executive" },
  { rank: 18, xp: 13000000, title: "Treasurer" },
  { rank: 17, xp: 8500000, title: "Senior" },
  { rank: 16, xp: 5500000, title: "Partner" },
  { rank: 15, xp: 3500000, title: "Trustee" },
  { rank: 14, xp: 2250000, title: "Chairman" },
  { rank: 13, xp: 1500000, title: "Board Member" },
  { rank: 12, xp: 1000000, title: "CFO" },
  { rank: 11, xp: 750000, title: "COO" },
  { rank: 10, xp: 500000, title: "Controller" },
  { rank: 9, xp: 330000, title: "Director" },
  { rank: 8, xp: 200000, title: "Associate" },
  { rank: 7, xp: 110000, title: "Strategist" },
  { rank: 6, xp: 60000, title: "Analyst" },
  { rank: 5, xp: 30000, title: "Professional" },
  { rank: 4, xp: 14000, title: "Day Trader" },
  { rank: 3, xp: 6000, title: "Investor" },
  { rank: 2, xp: 2000, title: "Novice" }
];

export function getMaxXpForRank(currentRank) {
  const nextRankEntry = rankTable.find(entry => entry.rank === currentRank + 1);
  return nextRankEntry ? nextRankEntry.xp : null;
}
